import {router} from './router';

$('body').on('click', '.inner-link', function (evtObj) {

    let target = evtObj.currentTarget;
    let href = target.getAttribute('href') || target.getAttribute('data-href');
    let trigger = target.dataset.trigger;

    // check external links
    if (href && href.match(/^(https?:)?\/\//)) {
        return;
    }

    // check system keys (open link in other tab)
    if (evtObj.ctrlKey || evtObj.shiftKey || evtObj.metaKey) {
        return;
    }

    if (typeof trigger === 'undefined') {
        trigger = true;
    }

    if (href.indexOf('__/') === 0) {

        router.navigateRelativelyToLocaleCode(href.replace('__/', '/'), {trigger: trigger});
    }
    else {

        router.navigate(href, {trigger: trigger});
    }

    evtObj.preventDefault();
});



// WEBPACK FOOTER //
// ./js/login/linking.js